"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var SpeisekarteModel_1 = require("../../models/SpeisekarteModel");
var CustomDropDown_1 = require("./CustomDropDown");
var SpeiseDialog = /** @class */ (function (_super) {
    __extends(SpeiseDialog, _super);
    function SpeiseDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.nameChanged = function (event, newValue) {
            var dish = _this.state.dish;
            dish.value = newValue;
        };
        _this.weightChanged = function (event, newValue) {
            var dish = _this.state.dish;
            dish.weight = newValue;
        };
        _this.priceChanged = function (event, newValue) {
            var dish = _this.state.dish;
            dish.price = newValue;
        };
        _this.literChanged = function (event, newValue) {
            var dish = _this.state.dish;
            dish.liter = newValue;
        };
        _this.ingredientsChanged = function (event, newValue) {
            var dish = _this.state.dish;
            dish.ingredients = newValue;
        };
        _this.additivesChanged = function (newAdditives) {
            var dish = _this.state.dish;
            dish.additives = newAdditives;
        };
        _this.onRenderFooterContent = function () { return (React.createElement("div", { style: { minWidth: '200px', maxWidth: '600px' } },
            React.createElement(office_ui_fabric_react_1.Stack, { tokens: { childrenGap: 20 }, horizontal: true },
                React.createElement(office_ui_fabric_react_1.Stack.Item, { align: "start", grow: true }, _this.state.dish.value !== null ?
                    React.createElement(office_ui_fabric_react_1.DefaultButton, { className: "ms-Cancel-Button", onClick: function () { return _this.confirmDeleteDialog(_this.state.dish); }, text: "L\u00F6schen", primaryDisabled: false }) :
                    React.createElement(office_ui_fabric_react_1.DefaultButton, { className: "ms-Cancel-Button", onClick: function () { return _this.confirmDialog(null); }, text: "Abbrechen", primaryDisabled: false })),
                React.createElement(office_ui_fabric_react_1.Stack.Item, { align: "end", grow: true, styles: { root: { alignContent: "flex-end", flexGrow: 0 } } },
                    React.createElement(office_ui_fabric_react_1.PrimaryButton, { className: "ms-Default-Button2", onClick: function () { _this.confirmDialog(_this.state.dish); }, text: "Speichern" }))))); };
        _this.updateData = function (data, categorie) {
            _this.setState({ dish: data, hideDialog: true, categorie: categorie });
        };
        _this.closeDialog = function () {
            _this.setState({ hideDialog: false });
        };
        _this.confirmDialog = function (dish) {
            _this.props.confirmedEvent(dish);
        };
        _this.confirmDeleteDialog = function (dish) {
            _this.props.deleteDishEvent(dish);
        };
        _this.state = {
            hideDialog: false, dish: new SpeisekarteModel_1.Dish(), categorie: ""
        };
        return _this;
    }
    SpeiseDialog.prototype.render = function () {
        var _this = this;
        return (React.createElement(office_ui_fabric_react_1.Panel, { isOpen: this.state.hideDialog, onDismiss: function () { return _this.confirmDialog(null); }, type: office_ui_fabric_react_1.PanelType.custom, customWidth: "500px", onRenderFooterContent: this.onRenderFooterContent, isFooterAtBottom: true, headerText: this.state.dish.value !== null ? this.state.dish.value + " bearbeiten" : "Neue Speise anlegen" },
            React.createElement("div", { style: { minWidth: "200px", maxWidth: "600px" } },
                React.createElement("div", { style: { paddingLeft: "20px", paddingRight: "20px", paddingBottom: "20px", marginTop: "20px" } },
                    React.createElement(office_ui_fabric_react_1.TextField, { label: "Name", required: true, defaultValue: this.state.dish.value, onChange: this.nameChanged }),
                    React.createElement(office_ui_fabric_react_1.TextField, { label: "Gewicht/Zusatztext", defaultValue: this.state.dish.weight, onChange: this.weightChanged }),
                    React.createElement(office_ui_fabric_react_1.TextField, { label: "Preis", required: true, defaultValue: this.state.dish.price, onChange: this.priceChanged }),
                    this.state.categorie === "Getränke" &&
                        React.createElement(office_ui_fabric_react_1.TextField, { label: "Liter", required: true, defaultValue: this.state.dish.liter, onChange: this.literChanged }),
                    React.createElement(office_ui_fabric_react_1.TextField, { label: "Zutaten", multiline: true, rows: 10, defaultValue: this.state.dish.ingredients, onChange: this.ingredientsChanged }),
                    React.createElement(CustomDropDown_1.CustomDropDown, { label: "Zus\u00E4tze", placeholder: "", data: this.props.data, additives: this.state.dish.additives, additivesChangedEvent: this.additivesChanged })))));
    };
    return SpeiseDialog;
}(React.Component));
exports.default = SpeiseDialog;
//# sourceMappingURL=NeueSpeise.js.map